export interface JoinOptions {
    limit?: number;
}